import { create } from "zustand";

/**
 * The client's ACTIVE org selection — the roster analogue of {@link useActiveBand}. A person
 * with seats in more than one org (a genuinely multi-seat user) picks which org's roster they are in; the
 * default is their first org seat. Like activeBand, this holds only the SELECTION (an id) — the effective role +
 * money + tab-set all come from the SERVER navigation document keyed on it (the `?as=` client override is dead).
 * Deliberately NOT store-reset-registered: an artist switch inside the roster must not clear which org is active.
 */
interface ActiveOrgState {
  activeOrgId: string | null;
  setActiveOrg: (orgId: string) => void;
  clear: () => void;
}

export const useActiveOrg = create<ActiveOrgState>((set) => ({
  activeOrgId: null,
  setActiveOrg: (orgId) => set({ activeOrgId: orgId }),
  clear: () => set({ activeOrgId: null }),
}));
